import {Routes, UrlTree} from '@angular/router';
import { IsAuthenticatedGuard } from 'src/app/guards/is.authenticated.guard';
import {
  EventComponent,
  EventDetailSections,
} from './components/event/event.component';
import { PassesComponent } from './components/event/passes/passes.component';
import { SessionsComponent } from './components/event/sessions/sessions.component';
import { SessiontracksComponent } from './components/event/sessiontracks/sessiontracks.component';
import { SpeakersComponent } from './components/event/speakers/speakers.component';
import { ConfirmationComponent } from './components/eventregistration/confirmation/confirmation.component';
import {
  EventCheckoutRoutePaths,
  EventRegistrationComponent,
} from './components/eventregistration/eventregistration.component';
import { FreeRegistrationComponent } from './components/eventregistration/free-registration/free.registration';
import { PaymentPaypalComponent } from './components/eventregistration/paymentpaypal/payment.paypal';
import { RegistrationFinalizeComponent } from './components/eventregistration/registrationfinalize/registration.finalize';
import { SessionSelectionComponent } from './components/eventregistration/session-selection/session-selection.component';
import { HomeComponent } from './components/home/home.component';
import { MyRegistrationsComponent } from './components/myregistrations/myregistrations.component';
import { PreviewComponent } from './components/preview/preview.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { RedirectGuard } from './guards/redirect.guard';
import { ExternalLoginUrlResolver } from './resolvers/external.login.url.resolver';
import { ExternalLogoutUrlResolver } from './resolvers/external.logout.url.resolver';
import { ExternalProfileUrlResolver } from './resolvers/external.profile.url.resolver';
import { ExternalUrlResolver } from './resolvers/external.url.resolver';
import { InternalUrlResolver } from './resolvers/internal.url.resolver';

// WARNING: Adding routes can break compatibility with hosted portal!
// Make sure to add a web page in Portals if you want to add an additional route.
export const AppRoutes: Routes = [
  { path: 'events', component: HomeComponent, canActivate: [RedirectGuard] },
  { path: 'eventsPreview', component: PreviewComponent, },
  { path: 'spinner', component: SpinnerComponent },
  {
    path: 'event',
    component: EventComponent,
    children: [
      {
        path: '',
        redirectTo: EventDetailSections.Sessions,
        pathMatch: 'prefix',
      },
      {
        path: EventDetailSections.Sessions,
        component: SessionsComponent,
      },
      {
        path: EventDetailSections.SessionTracks,
        component: SessiontracksComponent,
      },
      {
        path: EventDetailSections.Speakers,
        component: SpeakersComponent,
      },
      {
        path: EventDetailSections.PassInformation,
        component: PassesComponent,
      },
    ],
  },
  {
    path: EventCheckoutRoutePaths.REGISTRATION,
    component: EventRegistrationComponent,
    children: [
      {
        path: '',
        component: SessionSelectionComponent,
      },
    ],
  },
  {
    path: EventCheckoutRoutePaths.CONFIRMATION,
    component: ConfirmationComponent,
  },
  { path: EventCheckoutRoutePaths.PAYMENT, component: PaymentPaypalComponent },
  { path: EventCheckoutRoutePaths.FREE, component: FreeRegistrationComponent },
  {
    path: EventCheckoutRoutePaths.REGISTRATION_FINALIZE,
    component: RegistrationFinalizeComponent,
  },
  {
    path: 'externalLogin',
    resolve: { url: ExternalLoginUrlResolver },
    component: HomeComponent,
  },
  {
    path: 'externalLogout',
    resolve: { url: ExternalLogoutUrlResolver },
    component: HomeComponent,
  },
  {
    path: 'externalProfile',
    resolve: { url: ExternalProfileUrlResolver },
    component: HomeComponent,
  },
  {
    path: 'myregistrations',
    canActivate: [IsAuthenticatedGuard],
    component: MyRegistrationsComponent,
  },
  {
    path: 'externalRedirect',
    resolve: { url: ExternalUrlResolver },
    component: HomeComponent,
  },
  {
    path: 'internalRedirect',
    resolve: { url: InternalUrlResolver },
    component: PreviewComponent,
  },
  { path: '**', redirectTo: 'events' },
];
